import BottomButtonTemplate from "../common/BottomButtonTemplate";
import {ConsumptionDefaultBottomButtonsProps} from "../../types/consumptionDefaultBottomButtonsProps";
import { useTranslation } from "react-i18next";

export default function ConsumptionDefaultBottomButtons(props: ConsumptionDefaultBottomButtonsProps) {
    const { t } = useTranslation();
    return (
        <div id="div-bottom-buttons" className="row float-right btn-group margin-right-0" role="group" aria-label="Bottom action buttons">
            <BottomButtonTemplate text={t("main.rxg_Consumption")} enabled={props.consumptionOnline} func={props.consumptionOnlineFunc} />
            <BottomButtonTemplate text={t("main.offlineCons")} enabled={props.consumptionOffline} func={props.consumptionOfflineFunc} />
            <BottomButtonTemplate text={t("main.rxg_Work_Order_Enquiry")} enabled={props.workorderEnquiry} func={props.workorderEnquiryFunc} />
            <BottomButtonTemplate text={t("main.assign")} enabled={props.jobAssign} func={props.jobAssignFunc} />
            <BottomButtonTemplate text={t("main.changeCloseJob")} enabled={props.jobClose} func={props.jobCloseFunc}>
                <span id="btnBottomChangeCloseSpinner" className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ display: 'none' }}></span>
            </BottomButtonTemplate>
        </div>
    )
}
